import { Injectable } from '@angular/core';
import { AppInsightsService } from '@sb-tools/typescript/services/app-insights.service';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { TicketSource } from '@sb-tools/typescript/enums/ticket-source.enum';
import { FieldDTO } from '../models/field-gui-model.model';

@Injectable({
    providedIn: 'root',
})
export class FieldsLogService {
    fieldsFromTicket: FieldDTO[];

    constructor(
        private appInsightsService: AppInsightsService,
        private commonDataService: CommonDataService,
    ) {}

    checkCustomFieldEqual(ticketId: number, source: TicketSource) {
        const controlFields: string[] = [];
        const ticketFields: string[] = [];

        this.fieldsFromTicket?.forEach((field) => {
            ticketFields.push((field.name + ': ' + (field.transformedValue || field.value || '')).trim());
        });

        const elements = document.querySelectorAll<HTMLElement>('app-fields .label');
        elements.forEach((el) => {
            controlFields.push(el.textContent?.trim() || '');
        });

        const diffTicketToControl = ticketFields.filter((item) => !controlFields.includes(item));
        const diffControlToTicket = controlFields.filter((item) => !ticketFields.includes(item));
        const isEqual = diffTicketToControl.length === 0 && diffControlToTicket.length === 0;

        if (!isEqual) {
            this.appInsightsService.logEvent('Wrong custom field values', {
                'Custom fields from ticket': ticketFields,
                'Custom fields from control': controlFields,
                community: this.commonDataService.communityName,
                source,
                ticketId,
            });
        }
    }
}
